/* stylelint-disable selector-type-no-unknown */
.spacontainerv2 > agl-spa-shell > app-address-search {
  display: block;
  z-index: 500;
  margin-top: -50px;

  @include agl-ds-screen-size('large') {
    margin-top: -50px;
  }
}

.address-search {
  padding-top: $space-03;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px 1px rgb(43 46 49 / 16%);
  border-radius: 16px;
  background-color: $c-neutral-08;
  width: 100%;

  @include agl-ds-screen-size('large') {
    width: 83%;
    margin: 0 auto;
  }

  &__container {
    padding-left: $space-02;
    padding-right: $space-02;

    @include agl-ds-screen-size('medium') {
      padding-left: $space-04;
      padding-right: $space-04;
    }
  }

  &.standalone-box {
    border-radius: 16px;
    box-shadow: 0 4px 12px 1px #2b2e3129;
  }

  &__title {
    color: $c-neutral-01;
    font-size: 16px;
    font-weight: $font-weight-semi-bold;
    font-family: $font-family-02;

    @include agl-ds-screen-size('large') {
      font-size: 18px;
    }
  }

  &__input {
    width: 100%;

    /* stylelint-disable-next-line selector-id-pattern */
    #address-search-label_textBox {
      font-weight: $font-weight-regular;
      font-size: 16px;
      height: auto;
      padding-top: 12px;
      padding-bottom: 12px;
      line-height: 1.5;

      /* stylelint-disable-next-line selector-class-pattern */
      &.agl-ds-textbox-experiential__input--valid {
        border-bottom-color: $c-neutral-02;
      }
    }

    /* stylelint-disable-next-line selector-class-pattern */
    .loading-indicator.loading-indicator--experiential {
      top: 10px;
    }

    /* stylelint-disable-next-line selector-class-pattern */
    .text-input__icon.text-input__icon--experiential.sc-agl-ds-textbox {
      top: 10px;
    }
  }

  /* stylelint-disable-next-line selector-class-pattern */
  span.loading-overlay.loading-overlay--experiential {
    height: 40px;
  }

  &.center {
    margin: auto;
    padding-left: 16px;
    padding-right: 16px;
    width: 100%;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .message-container__validation-text-section {
    padding-left: 0;
  }

  .message-container {
    margin-bottom: 0;
  }

  .sq-message-container > p:last-of-type {
    margin-bottom: 0;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .agl-ds-autocomplete__dropdown--experiential {
    top: 50px;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  @include agl-ds-screen-size('medium') {
    /* stylelint-disable-next-line selector-class-pattern */
    .agl-ds-autocomplete__dropdown--experiential {
      top: 50px;
    }
  }

  .sq-message-container > h2,
  .sq-message-container > p:first-of-type > b:first-child {
    background-repeat: no-repeat;
    background-position: left center;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 24C14.3734 24 16.6935 23.2962 18.6668 21.9776C20.6402 20.6591 22.1783 18.7849 23.0866 16.5922C23.9948 14.3995 24.2324 11.9867 23.7694 9.65892C23.3064 7.33115 22.1635 5.19295 20.4853 3.51472C18.8071 1.83649 16.6689 0.693605 14.3411 0.230582C12.0133 -0.232441 9.60051 0.00519943 7.4078 0.913451C5.21509 1.8217 3.34094 3.35977 2.02236 5.33316C0.703788 7.30655 0 9.62663 0 12C0.000132598 15.1826 1.26446 18.2347 3.51487 20.4851C5.76527 22.7355 8.81744 23.9999 12 24ZM11 6.00001C11 5.73479 11.1054 5.48043 11.2929 5.2929C11.4804 5.10536 11.7348 5.00001 12 5.00001C12.2652 5.00001 12.5196 5.10536 12.7071 5.2929C12.8946 5.48043 13 5.73479 13 6.00001V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V6.00001ZM12 16C12.2967 16 12.5867 16.088 12.8334 16.2528C13.08 16.4176 13.2723 16.6519 13.3858 16.926C13.4994 17.2001 13.5291 17.5017 13.4712 17.7926C13.4133 18.0836 13.2704 18.3509 13.0607 18.5607C12.8509 18.7704 12.5836 18.9133 12.2926 18.9712C12.0017 19.0291 11.7001 18.9994 11.426 18.8858C11.1519 18.7723 10.9176 18.58 10.7528 18.3334C10.588 18.0867 10.5 17.7967 10.5 17.5C10.5 17.1022 10.658 16.7207 10.9393 16.4393C11.2206 16.158 11.6022 16 12 16Z' fill='%236031A6'/%3E%3C/svg%3E");
    padding-left: 32px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    display: block;
    clear: both;
    margin-bottom: 8px;
  }
}

/* stylelint-disable-next-line selector-class-pattern */
.address-search-techtype__container {
  background-color: $c-neutral-07;
  padding: $space-01 $space-02 $space-01 $space-02;
  border-radius: 0 0 16px 16px;

  @include agl-ds-screen-size('large') {
    padding-left: $space-04;
    padding-right: $space-04;
  }
}
